import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Navigation.css';

function Navigation() {
  return (
    <Navbar bg="white" expand="lg" className="shadow-sm sticky-top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="brand-logo">
   <span className="brand-icon">?</span>
          <span className="brand-text">YouSureAboutThat.ai</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
  <Navbar.Collapse id="basic-navbar-nav">
       <Nav className="ms-auto">
      <Nav.Link as={Link} to="/" className="nav-link-custom">
    Home
         </Nav.Link>
            <Nav.Link as={Link} to="/validator" className="nav-link-custom">
    Validator
            </Nav.Link>
  {/* Prepared for future authentication */}
      {/* <Nav.Link as={Link} to="/login" className="nav-link-custom">
           Login
  </Nav.Link> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navigation;
